import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_PRODUK_DEKRANASDA, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_PRODUK = 'GET_LIST_PRODUK';

export const getProduk = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_PRODUK);

    axios({
      method: 'get',
      url: GET_PRODUK_DEKRANASDA,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_PRODUK, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_PRODUK,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_PRODUK, error);
        alert(error);
      });
  };
};
